const transformYouTubeUrl = (url: string): string => {
  if (url.includes("youtube.com/watch?v=")) {
    // Transform the YouTube URL to an embed URL
    let embedUrl = url.replace("/watch?v=", "/embed/");
    // Remove the timestamp if present
    const timestampIndex = embedUrl.indexOf("&t=");
    if (timestampIndex !== -1) {
      embedUrl = embedUrl.substring(0, timestampIndex);
    }
    return embedUrl;
  }
  if (url.includes("youtube.com/shorts/")) {
    // Transform the YouTube Shorts URL to an embed URL
    return url.replace("/shorts/", "/embed/");
  }
  return url;
};

export default transformYouTubeUrl;
